import React from 'react';
import DOMPurify from 'dompurify';
import { useTheme } from 'ThemeContext';

import { Wrapper, Content } from './WidgetHTML.style';

function WidgetHTML({ data = '' }) {
  const theme = useTheme();
  return (
    <Wrapper>
      <Content
        theme={theme.CMS}
        dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(data) }}
      />
    </Wrapper>
  );
}

export default WidgetHTML;
